import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Trans} from '@modifi/plugin-i18n'
import {Row, Col, Paragraph, WhatsappIcon, Strong} from '@modifi/ui'
import {
  darkGray,
  airBlue,
  // semiDarkGray
} from '@modifi/colors'

import {CardWrapper, WhatsAppLink, PhoneNumber, RequestDemoWrapper} from './styles'
import {A} from '../../styles/typography'
import {StyledH4} from '../common'
import {
  generateWhatsappUrl,
  removeWhiteSpaces,
  // getCurrentTimeFromTimeZone
} from './utils'
import LinkComponent from '../link-component'
import {ctaMapping} from '../constants'
import RequestDemoButton from '../../features/common/request-demo-button/RequestDemoButton'
import {StyledButtonLight} from '../styles'

const componentMapping = {
  span: <span />,
  p: <Paragraph mt={0} mb={0} />,
  b: <b />,
  br: <br />,
}

const supportedCtaTypes = Object.keys(ctaMapping)

export const contactCardPropTypes = {
  cardDetails: PropTypes.shape({
    tab: PropTypes.oneOf(['tab-1', 'tab-2', 'tab-3', 'tab-4', 'tab-5', 'tab-6']),
    location: PropTypes.string.isRequired,
    locationNameForAnalytics: PropTypes.string,
    address: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    whatsappNumber: PropTypes.string,
    additionalInfo: PropTypes.string,
    timeZone: PropTypes.string,
    topCtaLabel: PropTypes.string,
    topCtaType: PropTypes.string,
    topCtaUrl: PropTypes.string,
    topCtaOpenInNewTab: PropTypes.bool,
    bottomCtaLabel: PropTypes.string,
    bottomCtaUrl: PropTypes.string,
    bottomCtaType: PropTypes.string,
    bottomCtaOpenInNewTab: PropTypes.bool,
  }).isRequired,
}
const defaultProps = {}

export type ContactCardProps = InferPropTypes<typeof contactCardPropTypes, typeof defaultProps>

// @todo need to fix the issue with real time
// const currentTime = getCurrentTimeFromTimeZone(cardDetails?.timeZone!)

export const ContactCard: React.FC<ContactCardProps> = ({cardDetails}) => (
  <CardWrapper>
    <Row>
      <Col>
        <StyledH4>{cardDetails?.location}</StyledH4>
      </Col>
    </Row>
    {/* {currentTime?.time && (
        <Row>
          <Col col="auto">
            <Paragraph color={semiDarkGray} mb={0} mt={0}>
              {currentTime.time}
            </Paragraph>
          </Col>
          <Col col="auto">{currentTime?.isWorkingHour ? <SunIcon /> : <MoonIcon />}</Col>
        </Row>
      )} */}
    <Row mt={8}>
      <Col>
        <Trans defaults={cardDetails.address || ''} components={componentMapping} />
      </Col>
    </Row>
    {cardDetails.additionalInfo && (
      <Row mt={8}>
        <Col>
          <Trans defaults={cardDetails.additionalInfo} components={componentMapping} />
        </Col>
      </Row>
    )}
    {cardDetails.phoneNumber && (
      <Row mt={8}>
        <Col>
          <PhoneNumber href={`tel:${removeWhiteSpaces(cardDetails.phoneNumber)}`} color={darkGray}>
            {cardDetails.phoneNumber}
          </PhoneNumber>
        </Col>
      </Row>
    )}
    {cardDetails.whatsappNumber && (
      <Row mt={8}>
        <Col>
          <WhatsAppLink
            href={generateWhatsappUrl(cardDetails.whatsappNumber)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappIcon height={20} width={20} />
            <Strong color={airBlue}>{cardDetails.whatsappNumber}</Strong>
          </WhatsAppLink>
        </Col>
      </Row>
    )}
    {cardDetails.email && (
      <Row mt={8}>
        <Col>
          <A href={`mailto: ${cardDetails.email}`} color={darkGray}>
            <Strong color={airBlue}>{cardDetails.email}</Strong>
          </A>
        </Col>
      </Row>
    )}
    {supportedCtaTypes.includes(cardDetails?.topCtaType || '') && (
      <Row mt={8}>
        <Col>
          <LinkComponent
            targetUrl={cardDetails?.topCtaUrl || ''}
            type={cardDetails?.topCtaType || ''}
            label={cardDetails?.topCtaLabel || ''}
            openInNewTab={cardDetails?.topCtaOpenInNewTab || false}
          />
        </Col>
      </Row>
    )}
    {cardDetails?.bottomCtaType && (
      <Row>
        <Col>
          <RequestDemoWrapper
            visibility={
              cardDetails?.bottomCtaType && cardDetails?.bottomCtaType !== 'none'
                ? 'visible'
                : 'hidden'
            }
          >
            <RequestDemoButton
              buttonComponent={ctaMapping[cardDetails?.bottomCtaType] || StyledButtonLight}
              icon
              url={cardDetails?.bottomCtaUrl}
              locationNameForAnalytics={cardDetails?.locationNameForAnalytics}
            >
              <span>{cardDetails?.bottomCtaLabel}</span>
            </RequestDemoButton>
          </RequestDemoWrapper>
        </Col>
      </Row>
    )}
  </CardWrapper>
)

ContactCard.propTypes = contactCardPropTypes

ContactCard.defaultProps = defaultProps

export default ContactCard
